import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../../hooks'

export const TerrorismFinancing = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.terroristFinancing"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="33. Terrorist Financing"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'33. Terrorist Financing'}
              direction={'vertical'}
              data={[
                { label: 'a. Known or suspected terrorist/terrorist organization', value: 'a' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
